export default __webpack_public_path__ + "static/media/exma.6f6a16ee.png";